const selectToasts = state => state.toasts

export { selectToasts }
